import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const ibanStatusTagFetchStateSlice = createSlice({
    name: 'ibanStatusTagFetchState',
    initialState: {
        dataValid: false,
        inProgress: false,
        statusTag: false,
        isIbanStatusTag: false,
    },
    reducers: {
        setDataValidity(state, action: PayloadAction<boolean>) {
            state.dataValid = action.payload;
        },
        setFetchProgress(state, action: PayloadAction<boolean>) {
            state.inProgress = action.payload;
        },
        setStatusTag(state, action: PayloadAction<boolean>) {
            state.statusTag = action.payload;
        },
        setIsIbanStatusTag(state, action: PayloadAction<boolean>) {
            state.isIbanStatusTag = action.payload;
        },
    },
});

export const ibanStatusTagFetchStateReducer = ibanStatusTagFetchStateSlice.reducer;
export const ibanStatusTagFetchStateActions = ibanStatusTagFetchStateSlice.actions;
